(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carsparkle-fitment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-bulb-finder')) {
  customElements.define('cs-bulb-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-meta]').textContent);
        this.text = JSON.parse(this.querySelector('[data-text]').textContent);
        this.rows = [...this.querySelectorAll('[data-records]')].flatMap(el => JSON.parse(el.textContent).map(r => [...r, el.dataset.records]));
        this.form = this.querySelector('form');
        this.year = this.querySelector('[name=year]');
        this.make = this.querySelector('[name=make]');
        this.model = this.querySelector('[name=model]');
        this.trim = this.querySelector('[name=trim]');
        this.result = this.querySelector('[data-results]');
        this.fill(this.year, [...new Set(this.rows.map(r => r[0]))].sort((a,b) => b-a));
        this.year.addEventListener('change', () => {this.clear();this.fill(this.make,this.values(1));this.fill(this.model,[]);});
        this.make.addEventListener('change', () => {this.clear();this.fill(this.model,this.values(2));});
        this.model.addEventListener('change', () => this.clear());
        this.trim.addEventListener('input', () => this.clear());
        this.form.addEventListener('submit', e => {e.preventDefault();this.search();});
        this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.fill(this.make,[]);this.fill(this.model,[]);this.clear();this.year.focus();});
        this.querySelector('[data-unlisted]').addEventListener('click',()=>{this.clear();this.result.append(this.el('p',this.text.no_match));this.contact(this.result);});
        this.querySelector('[data-status]').textContent=this.text.ready;
        this.querySelector('[type=submit]').disabled=false;
      } catch (_) {
        this.querySelector('[data-status]').textContent=this.querySelector('[data-error]').textContent;
      }
    }
    el(tag,text,cls) {const e=document.createElement(tag);if(text)e.textContent=text;if(cls)e.className=cls;return e;}
    fill(select,values) {
      select.replaceChildren(new Option(this.text.select,''));
      for(const value of values)select.add(new Option(String(value),String(value)));
      select.disabled=!values.length;
    }
    values(column) {
      const pool=this.rows.filter(r=>String(r[0])===this.year.value&&(column===1||this.data.makes[r[1]]===this.make.value));
      return [...new Set(pool.map(r=>column===1?this.data.makes[r[1]]:this.data.models[r[2]]))].sort((a,b)=>a.localeCompare(b));
    }
    clear() {this.result.replaceChildren();}
    contact(parent) {
      const a=this.el('a',this.text.contact,'csf-contact');
      const vehicle=[this.year.value,this.make.value,this.model.value,this.trim.value].filter(Boolean).join(' ');
      a.href='mailto:'+this.dataset.email+'?subject='+encodeURIComponent('Bulb fitment check: '+vehicle)+'&body='+encodeURIComponent('Vehicle: '+vehicle+'\nLighting position: \nFactory headlight type: \nOriginal bulb number: ');
      parent.append(a);
    }
    search() {
      if(!this.form.reportValidity())return;
      this.clear();
      const records=this.rows.filter(r=>String(r[0])===this.year.value&&this.data.makes[r[1]]===this.make.value&&this.data.models[r[2]]===this.model.value);
      const title=this.el('h3',[this.year.value,this.make.value,this.model.value].join(' '));
      this.result.append(title,this.el('p',this.text.trim_notice,'csf-muted'));
      const summary=this.el('ul','','csf-position-summary');
      summary.setAttribute('aria-label',this.text.summary);
      this.result.append(summary,this.el('p',this.text.alternatives,'csf-alternatives'));
      const grid=this.el('div','','csf-results-grid');
      for(const position of ['low','high','fog']) {
        const panel=this.el('section','','csf-position');panel.append(this.el('h4',this.text[position]));
        const relevant=records.filter(r=>this.data.meta[r[3]].positions.includes(position));
        const usable=relevant.filter(r=>!this.data.meta[r[3]].review);
        const sizes=[...new Set(usable.map(r=>r[4]))];
        const summaryItem=this.el('li');summaryItem.append(this.el('strong',this.text[position]),this.el('span',sizes.length===1?sizes[0]:this.text.not_confirmed));summary.append(summaryItem);
        if(!sizes.length){panel.append(this.el('p',this.text.no_match));this.contact(panel);grid.append(panel);continue;}
        if(sizes.length>1){panel.append(this.el('p',this.text.conflict));this.contact(panel);grid.append(panel);continue;}
        const size=sizes[0];panel.append(this.el('span',size,'csf-size'));
        const options=usable.filter(r=>r[4]===size);
        const unrestricted=options.some(r=>!this.data.meta[r[3]].condition);
        const cards=this.el('div','','csf-products');
        const template=this.querySelector('template[data-products="'+size+'"]');
        if(template)cards.append(template.content.cloneNode(true));
        for(const card of cards.querySelectorAll('.csf-card')) {
          card.prepend(this.el('p',this.text[position]+' · '+size,'csf-card-position'));
          const details=card.querySelector('h5')?.parentElement;
          if(details)details.insertBefore(this.el('p',this.text.use_for+' '+this.text[position]+' · '+size,'csf-use'),details.querySelector('h5'));
          const link=card.querySelector('.csf-shop');
          if(link){link.textContent=this.text.view_position.replace('[position]',this.text[position]);link.setAttribute('aria-label',this.text[position]+' · '+size+' · '+card.querySelector('h5').textContent);}
        }
        if(!cards.querySelector('a')){panel.append(this.el('p',this.text.unavailable));this.contact(panel);grid.append(panel);continue;}
        if(!unrestricted){
          cards.hidden=true;
          panel.append(this.el('p',this.text.configuration));
          const select=this.el('select');select.setAttribute('aria-label',this.text.configuration+' — '+this.text[position]);select.add(new Option(this.text.select,''));
          for(const ni of [...new Set(options.map(r=>r[3]))])select.add(new Option(this.data.meta[ni].condition,String(ni)));
          select.add(new Option(this.text.unsure,'unknown'));
          const label=this.el('label','','csf-confirm');const check=this.el('input');check.type='checkbox';
          label.append(check,this.el('span',this.text.confirm));label.hidden=true;
          select.addEventListener('change',()=>{check.checked=false;cards.hidden=true;label.hidden=!select.value||select.value==='unknown';});
          check.addEventListener('change',()=>{cards.hidden=!check.checked;});
          panel.append(select,label);
        }
        panel.append(this.el('p',this.text.match_note,'csf-muted'),cards);this.contact(panel);grid.append(panel);
      }
      this.result.append(grid);
      if(records.some(r=>this.data.meta[r[3]].review))this.result.append(this.el('p',this.text.held,'csf-muted'));
      this.result.setAttribute('tabindex','-1');this.result.focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
